<ef-loading-container
    [observables]="[process$, accounts$, contracts$]"
></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="scroll-container card" fullscreen>
    <ef-account-allocations
        [accounts]="accounts$ | async"
        [contracts]="contracts$ | async"
        [selectedError]="selectedErrorWithStatus$ | async"
        (ShowError)="onShowError($event)"
    ></ef-account-allocations>
</div>
